import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[appOverflowTooltip]',
  exportAs: 'appOverflowTooltip',
  providers: [MatTooltip],
})
export class OverflowTooltipDirective {
  constructor(
    private el: ElementRef,
    private tooltip: MatTooltip
  ) {}

  @Input('appOverflowTooltip') public text = '';

  @HostListener('mouseenter')
  public onMouseEnter(): void {
    const element = this.el.nativeElement;
    if (element.scrollWidth > element.clientWidth) {
      this.tooltip.message = this.text || element.textContent?.trim();
      this.tooltip.position = 'above';
      this.tooltip.show();
    }
  }

  @HostListener('mouseleave')
  public onMouseLeave(): void {
    this.tooltip.hide();
  }
}
